var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 36,
  viewBox: "0 0 42 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 36,
  rx: 18,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 16.4673C12 15.5415 12.4274 14.6676 13.1582 14.0992L19.1582 9.43253C20.2415 8.58994 21.7585 8.58994 22.8418 9.43253L28.8418 14.0992C29.5726 14.6676 30 15.5415 30 16.4673V26C30 26.5304 29.7893 27.0391 29.4142 27.4142C29.0391 27.7893 28.5304 28 28 28H14C13.4696 28 12.9609 27.7893 12.5858 27.4142C12.2107 27.0391 12 26.5304 12 26V16.4673Z",
  stroke: "#333333",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 28V18H24V28",
  stroke: "#333333",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconHome;